<header>
  <div class="overlay"></div>
  <div class="topButtons">
    <div
      (click)="toggleAppMenu()"
      (mouseenter)="hover('apps')"
      (mouseleave)="hover('')"
      class="clickable"
      id="AppsButton"
      matTooltip="Select Application"
      matTooltipPosition="below"
      matTooltipShowDelay="500"
      >
      <div class="clicked"></div>
      <div class="circle"></div>
      <div class="icon"></div>
    </div>
    <div class="divider-line"></div>
    @if (true && (selectedApp === 'networks' || selectedApp === 'infrastructure')) {
      <div
        [ngClass]="{ open: area === 'Network', disabled: false }"
        class="clickable main header-nav-icon"
        id="NavigationButton"
        [matTooltip]="apiService.isNetworkClusterReadOnly() ? 'Network is Read Only' : ''"
        matTooltipPosition="below"
        matTooltipShowDelay="300"
        (click)="goToNetworkDashboard($event)"
        >
        <div class="clicked"></div>
        <div class="main status s{{ currentNetwork.status }}" [ngClass]="{'read-only': apiService.isNetworkClusterReadOnly(currentNetwork)}">
          <div class="anim5"></div>
          @if (currentNetwork?.haEnabled) {
            <div class="ha-badge"></div>
          }
          @if (currentNetwork?.fipsEnabled) {
            <div class="fips-badge">FIPS</div>
          }
        </div>
        <div class="circle"></div>
        <div [hidden]="currentNetwork.status === 200" class="icon"></div>
      </div>
    }
    @if (selectedApp !== 'networks' && selectedApp !== 'infrastructure') {
      <div
        class="clickable main header-nav-icon nav-button-{{selectedApp}}"
        id="ApplicationButton"
        (click)="goToPage($event)"
        >
        <div class="clicked"></div>
        <div class="circle"></div>
        <div class="icon"></div>
      </div>
    }
    <div class="header-title-wrapper">
      <div class="header-title-container">
        @if (false) {
          <div
            [ngClass]="{ open: area === 'Network', disabled: false }"
            class="clickable main"
            id="NavigationButton"
            >
            <div class="clicked"></div>
            <div class="main status s{{ currentNetwork.status }}"></div>
            <div class="circle"></div>
            <div [hidden]="currentNetwork.status === 200" class="icon"></div>
          </div>
        }
        <div class="header-title-label" (click)="goToPage($event)">{{appNameMap[selectedApp]}}</div>
      </div>
      <div class="header-breadcrumb">
        @if (selectedApp !== 'customers' && selectedApp !== 'organization' && selectedApp !== 'frontdoor') {
          <div class="breadcrumb-path-label" (click)="goToNetworkGroupsPage($event)">{{currentNetworkGroup.name}}</div>
        }
        @if (selectedApp === 'organization') {
          <div class="breadcrumb-path-label non-click">{{currentOrganization.name}}</div>
        }
        @if (selectedApp === 'frontdoor') {
          <div (click)="goToOrgsPage($event)" class="breadcrumb-path-label">{{currentOrganization.name}}</div>
        }
        @if (selectedApp === 'customers') {
          <div class="breadcrumb-path-label non-click">{{currentCustomer.name}}</div>
        }
        @if (selectedApp !== 'customers' && selectedApp !== 'organization' && selectedApp !== 'billing' && selectedApp !== 'frontdoor' && selectedApp !== 'on_prem') {
          <div class="breadcrumb-path-divider">/</div>
        }
        @if (selectedApp !== 'customers' && selectedApp !== 'organization' && selectedApp !== 'billing' && selectedApp !== 'frontdoor' && selectedApp !== 'on_prem') {
          <div class="breadcrumb-path-label" (click)="goToNetworksPage($event)">{{currentNetwork.name}}</div>
        }
        @if (pageNamePath) {
          <div class="breadcrumb-path-divider">/</div>
        }
        @if (pageNamePath) {
          <div class="breadcrumb-path-label non-click">{{pageNamePath}}</div>
        }
      </div>
    </div>
  </div>
  <div class="bottomButtons">
    <div
      (click)="open('Alerts')"
      class="clickable"
      id="AlertButton"
      matTooltip="Recent Alerts"
      matTooltipPosition="below"
      matTooltipShowDelay="500"
      >
      <div class="circle"></div>
      <div class="icon"></div>
      <div [ngClass]="{ open: popup === 'Notifications' }" class="hover">Recent Alerts</div>
    </div>
    <div
      (click)="open('Support')"
      [ngClass]="{ open: area === 'Support' }"
      class="clickable"
      id="HelpButton"
      matTooltip="Support"
      matTooltipPosition="below"
      matTooltipShowDelay="500"
      >
      <div class="clicked"></div>
      <div class="circle"></div>
      <div class="icon"></div>
      <div [ngClass]="{ open: popup === 'Support' }" class="hover">Support</div>
    </div>
    @if (this.authService.canListCustomers()) {
      <div
        (click)="open('Customers')"
        [ngClass]="{ open: area === 'Customers' }"
        class="clickable icon-customer"
        matTooltip="Customers"
        matTooltipPosition="below"
        matTooltipShowDelay="500"
        >
        <div class="clicked"></div>
        <div class="circle"></div>
        <div class="icon"></div>
        <div [ngClass]="{ open: popup === 'Customers' }" class="hover">Customers</div>
      </div>
    }

    <div
      class="clickable main"
      id="ProfileButton"
      (clickOutside)="hover('')"
      (click)="open('Profile')"
      >
      <div class="main clickable"></div>
      <div class="circle"></div>
      <div
        [ngStyle]="{ 'background-image': 'url(' + photo + ')' }"
        class="icon"
      ></div>
      @if (authService.isSupportUser() || authService.isSupportReadOnlyUser()) {
        @if (popup === 'profile') {
          <div class="profile-menu-anchor">
            <netfoundry-ui-profile-menu
              [name]="username"
              [photo]="photo"
              [billingInvalid]="billingStatusInvalid"
              [theme]="currentTheme"
              [betaEnabled]="betaEnabled"
              (themeChange)="setTheme($event)"
              (betaToggle)="toggleBeta()"
              (logout)="confirmLogout()"
              (menuClose)="popup = ''">
            </netfoundry-ui-profile-menu>
          </div>
        }
      } @else {
        <div [ngClass]="{ open: popup === 'profile' }" class="header-menu" id="ProfileMenu">
          @if (popup === 'profile' ) {
            <div class="menutitle">{{ username }}</div>
          }
          @if (!billingStatusInvalid && popup === 'profile' ) {
            <div
              class="link"
              id="EditProfile"
              routerLink="/profile/"
              >
              Edit Profile
            </div>
          }
          @if (!billingStatusInvalid && popup === 'profile') {
            <div
              class="link"
              id="PersonalSettings"
              routerLink="/user-settings/"
              >
              Personal Settings
            </div>
          }
          @if (popup === 'profile') {
            <div (click)="confirmLogout()" class="link" id="LogoutButton">Logout</div>
          }
        </div>
      }
    </div>
  </div>
</header>

@if (showAppMenu) {
  <div class="app-menu-container" (clickOutside)="closeAppMenu()">
    <div class="app-menu-group">
      <div class="switch-to-label">Switch to</div>
      @if (authService.canListNetworks(currentNetworkGroup.id)) {
        <div
          class="app-menu-item networks"
          (click)="appSelected('networks')"
          [title]="networkAppTooltip"
          >
          <div class="app-menu-item-icon"></div>
          <div class="app-menu-item-label network">Network</div>
          @if (selectedApp === 'networks') {
            <div class="check-selected"></div>
          }
          @if (controllerService.loadingZitiController) {
            <span class="spinner"></span>
          }
        </div>
      }
      @if (authService.canListUserIdentities()) {
        <div class="app-menu-item organization" (click)="appSelected('organization')">
          <div class="app-menu-item-icon"></div>
          <div class="app-menu-item-label network">Organization</div>
          @if (selectedApp === 'organization') {
            <div class="check-selected"></div>
          }
        </div>
      }
      <!-- Frontdoor on the v1/v2 API. It shows only when the current tenant has a v1/v2 frontdoor. -->
      @if (authService.canListFrontdoors() && hasLegacyFrontdoor) {
        <div class="app-menu-item frontdoor" (click)="appSelected('frontdoor')">
          <div class="app-menu-item-icon icon-front-door"></div>
          <div class="app-menu-item-label network">Frontdoor</div>
          @if (selectedApp === 'frontdoor') {
            <div class="check-selected"></div>
          }
        </div>
      }
      <!-- Frontdoor on the v3 API, which replaces the entry above. It shows only when the user can reach a v3
           frontdoor, so a tenant with both kinds sees both entries. -->
      @if (authService.canListFrontdoors() && hasV3Frontdoors) {
        <div class="app-menu-item fd" (click)="appSelected('fd')">
          <div class="app-menu-item-icon icon-front-door"></div>
          <div class="app-menu-item-label network">
            Frontdoor
            <span class="nf-badge nf-badge--info">New</span>
          </div>
          @if (selectedApp === 'fd') {
            <div class="check-selected"></div>
          }
        </div>
      }
      @if (authService.canListSoftwareAccess()) {
        <div class="app-menu-item support" (click)="appSelected('on_prem')">
          <div class="app-menu-item-icon icon-CAs"></div>
          <div class="app-menu-item-label network">Self-Hosted</div>
          @if (selectedApp === 'on_prem') {
            <div class="check-selected"></div>
          }
        </div>
      }
      @if (authService.canViewBillingSubscriptions() && enterpriseBilling) {
        <div
          class="app-menu-item billing"
          (click)="appSelected('billing')"
          [ngClass]="{ disabled: !currentAccount.id }"
          [title]="!currentAccount?.id ? 'No billing account associated with this organization' : ''"
          >
          <div class="app-menu-item-icon"></div>
          <div class="app-menu-item-label network">Billing</div>
          @if (selectedApp === 'billing') {
            <div class="check-selected"></div>
          }
        </div>
      }
    </div>
    @if (showMore) {
      <div class="app-menu-group">
        <div class="switch-to-label">More</div>
        @if (showOpperations) {
          <div class="app-menu-item support" (click)="appSelected('support_operations', SUPPORT_OPERATIONS)">
            <div class="app-menu-item-icon alternate icon-support"></div>
            <div class="app-menu-item-label network">Operations</div>
            @if (selectedApp === 'support_operations') {
              <div class="check-selected"></div>
            }
          </div>
        }
        @if (showCustomers) {
          <div class="app-menu-item customers" (click)="appSelected('customers', CUSTOMERS)">
            <div class="app-menu-item-icon alternate icon-customer"></div>
            <div class="app-menu-item-label network">Customers</div>
            @if (selectedApp === 'customers') {
              <div class="check-selected"></div>
            }
          </div>
        }
      </div>
    }
  </div>
}
